<template>
    <div class="context common_table_view">
        <div class="header">
            <div class="btn_box">
                <el-button type="danger" @click="readAll" size="small">
                    全部已读
                </el-button>
            </div>
        </div>
        <div class="table list_box" v-if="tableData && tableData.length > 0">
            <div class="list_td" v-for="(item, index) in tableData"
                :class="item.is_read == 1 ? 'not_read' : 'mark_read'" @click="readMore(item)" :key="index">
                <div class="icon_box">
                    <span class="iconfont icon-dian" v-if="item.is_read == 1" style="color: #fc5027; "></span>
                    <span class="iconfont icon-dian" v-else style="color: #939393"></span>
                </div>
                <div class="message_box">
                    {{ item.content }}
                </div>
                <div class="date_box">
                    {{ item.create_time }}
                </div>
            </div>
        </div>
        <div class="table list_box msg_not" v-else>
            <div class="msg_text">
                暂无消息
            </div>
        </div>

        <div class="bottom_page">
            <page-view @getTableList="handleCurrentChange"
                       :currentPage="currentPage"
                       :pageSize="pageSize"
                       :total="total"></page-view>
        </div>
    </div>
</template>

<script>
export default {
    name: "tableView",
    data() {
        const showRead = (row, cellValue, column, index) => {
            let text = cellValue == 1 ? '未读' : cellValue == 2 ? '已读' : '';
            return text
        };
        return {
            tableData: [],
            columnData: [
                { label: '消息类型', prop: 'message_type' },
                { label: '消息内容', prop: 'content' },
                { label: '是否已读', prop: 'is_read', formatter: showRead },
                { label: '操作时间', prop: 'create_time' },
            ],
            // data_list: {
            //             message_id,
            //             message_type REG_AUDIT INVOICE_AUDIT PATIENT_VISIT
            //             user_id,
            //             content,
            //             is_read 1否2是，
            //     item_id 患者注册值是患者user_id, 发票审核值是submit_id，随访值是task_id
            // }
            total: 0,
            currentPage: 1,
            pageSize: 50,
        }
    },
    mounted() {
        this.getTableData()
    },
    methods: {
        handleCurrentChange(v) {
            this.getTableData(v)
        },
        getTableData(v = 1) {
            let params = {
                // is_read 1 否 2 是 不传是全部,
                page: v,
                page_size: this.pageSize,
            };
            this.httpGet('/message/list', params).then(res => {
                this.tableData = res.data.data_list;
                this.total = res.data.total;
                this.$nextTick(() => {
                    this.currentPage = v
                })
            })
        },

        readMore(row) {
            if (row.is_read == 2) return; // 未读的点击之后才会已读
            let params = {
                message_id: row.message_id
            };
            this.httpPost('/message/read', params).then(res => {
                this.getTableData()
            })
        },
        readAll() {
            this.httpPost('/message/read_all').then(res => {
                this.$message.success('全部已读完成！');
                this.getTableData()
            })
        }
    }
}
</script>

<style scoped lang="scss">
.context {
    width: 100%;
    height: 100%;
    background: #f6f8f9;

    .list_box {
        flex: 1;
        background: #fff;
        border: 1px solid #e6e6ea;
        border-radius: 5px;
        margin: 10px 20px;
        height: 100%;
        width: auto;
        padding: 20px;
        box-sizing: border-box;
        cursor: pointer;
        overflow-y: auto;
        .list_td {
            display: flex;
            line-height: 40px;
            font-size: 0.875rem;
            border-bottom: 1px solid #e6e6ea;

            &:first-child {
                margin-top: 5px;
                border-top: 1px solid #e6e6ea;
            }

            .icon_box {
                flex: 0 0 60px;
                padding: 0 5px;
                text-align: right;
            }

            .message_box {
                flex: 1;
                padding: 0 5px;
                text-align: left;
            }

            .date_box {
                flex: 0 0 160px;
                padding: 0 5px;
                text-align: left;
            }
        }

        .not_read {
            color: #262626;
        }

        .mark_read {
            color: #939393;
        }
    }

    .msg_not {
        position: relative;

        .msg_text {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            color: #939393;
        }
    }
}
</style>